export const FLAG = {
  SELLER_UNDER_OFFER_CONVERSIONS: 'swa_under_offer_conversions',
  SELLER_UNDER_OFFER_POC: 'seller_under_offer_poc',
  SWA_AUTH_UI: 'swa_auth_ui',
  SWA_HOME_HERO_IMAGE: 'swa_hero_image',
  SWA_INCODE_DOCUMENT_CAPTURE: 'swa_incode_document_capture_seller_verification',
  SWA_PERCENTAGE_COMPLETION: 'swa_percentage_completion',
  SWA_PRIMARY_BUTTON: 'swa_primary_button',
  SWA_SIGN_UP_POSTCODE: 'mw_19_0_postcode_on_contact_details_page',
  SWA_VEHICLE_HUB: 'swa_vehicle_hub',
} as const;

export const EVENT = {
  ENQUIRY_CREATED: 'enquiry_created',
  ENQUIRY_LOADED: 'enquiry_load',
  EXPIRED_LINK_LOAD: 'expired_link_load',
  HERO_MILEAGE_CTA_CLICKED: 'valuations_hero_mileage_cta_clicked',
  HERO_VRM_CTA_CLICKED: 'valuations_hero_vrm_cta_clicked',
  OFFER_SELECT: 'offer_select',
  PS_ACCEPT_OFFER_CTA_CLICKED: 'ps_accept_offer_cta_clicked',
  PS_COMPLETE_SALE_CTA_CLICKED: 'ps_complete_sale_cta_clicked',
  SELLER_UNDER_OFFER_POC: 'post_sale_poc',
  SIGN_IN_CTA_CLICKED: 'sign_in_cta_clicked',
  SIGN_IN_LOADED: 'sign_in_load',
  SIGN_IN_SUCCESS_LOAD: 'sign_in_success_load',
  SIGN_UP_CTA_CLICKED: 'sign_up_cta_clicked',
  SIGN_UP_LOADED: 'sign_up_load',
  SIGN_UP_TOOLTIP_SHOW: 'contact_details_page_info_hover',
  SMV_MILEAGE_CTA_CLICKED: 'smv_mileage_cta_clicked',
  VALUATIONS_LOADED: 'valuations_load',
  VALUATIONS_MILEAGE_CTA_CLICKED: 'valuations_mileage_cta_clicked',
  VEHICLE_HUB_VIEW_SECTIONS: 'vehicle_hub_view_sections',
} as const;

export const EXPERIMENT_DECISIONS_HEADER = 'experiment-decisions';
